import client from "@/api/client/axios";
import type { ResponseConfig } from "@/api/client/axios";
import type { CheckBeforeSignCryptoQueryResponse } from "../../types/CheckBeforeSignCrypto";

/**
     * @summary Проверка параметров организации перед подписанием оферты с помощью УКЭП
     * @link /api/orders/sign-crypto/check
     */
export async function checkBeforeSignCrypto (options: Partial<Parameters<typeof client>[0]> = {}): Promise<ResponseConfig<CheckBeforeSignCryptoQueryResponse>["data"]> {
    const { data: resData } = await client<CheckBeforeSignCryptoQueryResponse>({
        method: "get",
        url: `/api/orders/sign-crypto/check`,
        ...options
    });
    
    return resData;
};